import { HeatmapLayer } from '@deck.gl/aggregation-layers';

// google.maps.visualization.HeatmapLayer's default gradient, so Coverage Mode keeps the colors it
// had before Google deprecated that layer. The gradient's leading fully transparent stop is left
// out on purpose - deck.gl fades the low end of the ramp out on its own.
export const HEATMAP_COLOR_RANGE = [
  [0, 255, 255],
  [0, 191, 255],
  [0, 127, 255],
  [0, 63, 255],
  [0, 0, 255],
  [0, 0, 223],
  [0, 0, 191],
  [0, 0, 159],
  [0, 0, 127],
  [63, 0, 91],
  [87, 0, 63],
  [111, 0, 31],
  [143, 0, 0],
  [159, 0, 0],
  [175, 0, 0],
  [191, 0, 0],
  [207, 0, 0],
  [223, 0, 0],
  [239, 0, 0],
  [255, 0, 0],
];

// Matches the options the google.maps.visualization.HeatmapLayer was created with
export const HEATMAP_RADIUS_PIXELS = 20;
export const HEATMAP_OPACITY = 0.6;

export const COVERAGE_HEATMAP_LAYER_ID = 'coverage-heatmap';

// deck.gl positions are [longitude, latitude]
export const getCoverageHeatmapPoints = (markers) =>
  markers
    .map((marker) => [Number(marker.meta?.long), Number(marker.meta?.lat)])
    .filter(([long, lat]) => Number.isFinite(long) && Number.isFinite(lat));

export const createCoverageHeatmapLayer = (points) =>
  new HeatmapLayer({
    id: COVERAGE_HEATMAP_LAYER_ID,
    data: points,
    getPosition: (point) => point,
    radiusPixels: HEATMAP_RADIUS_PIXELS,
    opacity: HEATMAP_OPACITY,
    colorRange: HEATMAP_COLOR_RANGE,
  });
